import '@babel/polyfill';
import React from 'react';
import { MainContentCrash } from './MainContentCrash';
import { SearchApp } from '../../../search/components/search-layout/SearchApp';

type Props = {
  children: React.ReactNode;
  shouldDisplaySearch: boolean;
};

type State = {
  hasError: boolean;
};

export class MainContent extends React.Component<Props, State> {
  state: State = {
    hasError: false,
  };

  static getDerivedStateFromError(error: Error) {
    console.log(error);
    if (window.Rollbar)
      window.Rollbar.critical(error, { source: 'page content' });
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  render() {
    const { shouldDisplaySearch } = this.props;

    if (this.state.hasError) {
      return <MainContentCrash />;
    }
    return (
      <>
        {shouldDisplaySearch && <SearchApp />}
        {!shouldDisplaySearch && this.props.children}
      </>
    );
  }
}
